import type { IPageLayout } from '@/layout/PageLayout/types';

const PageLayout = ({ children }: IPageLayout) => (
    <div className='clearance container fluid-default margin-x-auto'>{children}</div>
);

export default PageLayout;
